export default [
    { category: "block", url: "./textures/block/crate.png" },
    { category: "block", url: "./textures/block/colors.png" },
    { category: "block", url: "./textures/block/brick.jpg" },
    { category: "block", url: "./textures/block/block.jpg" },
    { category: "block", url: "./textures/block/Wood_5.png" },
    { category: "block", url: "./textures/block/Wood_4.png" },
    { category: "block", url: "./textures/block/Wood_3.png" },
    { category: "ground", url: "./textures/ground/Soil.png" },
    { category: "ground", url: "./textures/ground/Lava.png" },
    { category: "ground", url: "./textures/ground/Ice.png" },
    { category: "ground", url: "./textures/ground/Ground_5.png" },
    { category: "ground", url: "./textures/ground/Ground_4.png" },
    { category: "ground", url: "./textures/ground/Ground_3.png" },
    { category: "ground", url: "./textures/ground/Ground_2.png" },
    { category: "ground", url: "./textures/ground/Ground_1.png" },
    { category: "ground", url: "./textures/ground/Grass_3.png" },
    { category: "ground", url: "./textures/ground/Grass_2.png" },
    { category: "ground", url: "./textures/ground/Grass_1.png" },
    { category: "ground", url: "./textures/ground/Earth 3.png" },
    { category: "ground", url: "./textures/ground/Earth 2.png" },
    { category: "ground", url: "./textures/ground/Earth 1.png" },
    { category: "ground", url: "./textures/ground/grass.jpg" },
    { category: "ground", url: "./textures/ground/grass_overcast.png" },
    { category: "ground", url: "./textures/ground/earth_2.JPG" },
    { category: "ground", url: "./textures/floor/Floor_2.png" },
    { category: "ground", url: "./textures/floor/Floor_1.png" },
    { category: "ground", url: "./textures/floor/floor1.jpg" },
    { category: "ground", url: "./textures/floor/floor.jpg" },
    { category: "ground", url: "./textures/floor/tile_tantiles.jpg" },
    { category: "ground", url: "./textures/floor/ground.jpg" },
    { category: "ground", url: "./textures/floor/castle_ground_4.jpg" },
    { category: "ground", url: "./textures/floor/castle_ground_3.jpg" },
    { category: "ground", url: "./textures/floor/castle_ground_5.jpg" },
    { category: "ground", url: "./textures/floor/castle_ground_2.jpg" },
    { category: "ground", url: "./textures/floor/castle_ground_1.jpg" },
    { category: "ground", url: "./textures/floor/wood floor 2.png" },
    { category: "ground", url: "./textures/floor/Wood.jpg" },
    { category: "wall", url: "./textures/wall/Wall_3.png" },
    { category: "wall", url: "./textures/wall/Wall_2.png" },
    { category: "wall", url: "./textures/wall/Wall_1.png" },
    { category: "wall", url: "./textures/wall/Wall 2.png" },
    { category: "wall", url: "./textures/wall/Wall 1.png" },
    { category: "wall", url: "./textures/wall/TreeBark.png" },
    { category: "wall", url: "./textures/wall/Roof_2.png" },
    { category: "wall", url: "./textures/wall/Roof_1.png" },
    { category: "wall", url: "./textures/wall/Rock 2.png" },
    { category: "wall", url: "./textures/wall/Rock 1.png" },
    { category: "wall", url: "./textures/wall/Metal wall.png" },
    { category: "wall", url: "./textures/wall/wall-window.jpg" },
    { category: "wall", url: "./textures/wall/GreyBricks2.jpg" },
    { category: "wall", url: "./textures/wall/StoneWall1.jpg" },
    { category: "wall", url: "./textures/wall/Claimedwall2C.png" },
    { category: "wall", url: "./textures/wall/castle_wall_4.jpg" },
    { category: "wall", url: "./textures/wall/castle_wall_5.jpg" },
    { category: "wall", url: "./textures/wall/sand_wall.jpg" },
    { category: "wall", url: "./textures/wall/castle_wood_2.jpg" },
    { category: "wall", url: "./textures/wall/castle_wood_1.jpg" },
    { category: "wall", url: "./textures/wall/castle_wall_2.jpg" },
    { category: "wall", url: "./textures/wall/3TD_Office_Lite_vert.jpg" },
    { category: "wall", url: "./textures/wall/3TD_OfficeCedar_vert.jpg" },
    { category: "wall", url: "./textures/wall/cegla2.jpg" },
    { category: "wall", url: "./textures/wall/palki2.jpg" },
    { category: "wall", url: "./textures/wall/dachowki.jpg" },
    { category: "wall", url: "./textures/wall/deski2.jpg" },
    { category: "wall", url: "./textures/wall/rock_side.JPG" },
    { category: "wall", url: "./textures/wall/wall.jpg" },
    { category: "wall", url: "./textures/wall/vol_2_2_Height.png" },
    { category: "wall", url: "./textures/wall/vol_2_2_Base_Color.png" },
    { category: "wall", url: "./textures/wall/Wood_2.png" },
    { category: "wall", url: "./textures/wall/Wood_1.png" }
]